








import { Component, Vue, Watch } from "vue-property-decorator";
import Liff from "@line/liff";

import Layout from "./views/Layout.vue";
import Home from "./views/Home.vue";
import { LoadingStatusType } from "./enums/enums";
import IsLoading from "@/components/element/IsLoading.vue";

import { namespace } from "vuex-class";
import { NewObject } from "./helper/shareHelper";
const StoreLineToken = namespace("LineToken");

@Component({
  components: { Layout, Home, IsLoading },
})
export default class App extends Vue {
  private useLayoutPage = false;

  @Watch("$route", { immediate: true })
  RouteChanged(newVal: any, oldVal: any) {
    if (newVal.name) {
      this.SetUseLayoutPage(newVal.name);
    }
  }

  public SetUseLayoutPage(routerName: string) {
    switch (routerName) {
      case "login":
      case "selectList":
      case "logout":
      case "desktopView":
        this.useLayoutPage = false;
        break;

      default:
        this.useLayoutPage = true;
        break;
    }
  }
}
